import React, { useRef } from "react";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { API, fileUpload } from "../../../../config";
import Spin from "../../../common/Spin";
import { MultiSelect } from "primereact/multiselect";
import { useProjectListBasedOnBuilder } from "../../../Builders/Projects/components/ProjectsHelper";
import { formatName } from "../../../common/Misc";

const BuilderAcceptInvitation = ({
  id,
  showAcceptInvitation,
  handleInvitations,
  toggleShowAcceptInvitationModal,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const builderId = localStorage.getItem("builderId")
    ? localStorage.getItem("builderId")
    : "";
  const roleType = localStorage.getItem("roleType");
  const builderUserId = localStorage.getItem("builderUserId")
    ? localStorage.getItem("builderUserId")
    : "";

  const handleAcceptInvitation = async () => {
    const formData = new FormData();
    formData.append("status", 1);
    if (selectedProjects) {
      if (selectedProjects.length > 0) {
        for (let i = 0; i < selectedProjects.length; i++) {
          formData.append(`builder_project_ids[${i}]`, selectedProjects[i]);
        }
      }
    }
    formData.append("_method", "PUT");
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${
          roleType === "Builder" ? API.ACCOUNTING_INVITATIONS : API.INVITATIONS
        }/${id}`,
        formData
      );
      setLoading(false);
      toast.success(data?.message);
      handleInvitations();
      toggleShowAcceptInvitationModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  const handleProjectChange = (e, setFieldValue) => {
    setSelectedProjects(e.value);
  };

  const filterProjectInputRef = useRef();

  const handleProjectApplyFilter = () => {
    filterProjectInputRef.current.hide();
  };

  const ProjectResetFunction = () => {
    setSelectedProjects([]);
    filterProjectInputRef && filterProjectInputRef.current.focus();
    filterProjectInputRef.current.hide();
  };

  //Project List
  const { projectLoading, projectList = [] } = useProjectListBasedOnBuilder(
    builderId,
    builderUserId
  );
  const projectListing = projectList?.map((item) => {
    const name =
      item?.project_name +
      (item?.assigned_to
        ? ` (Assign to ${
            item?.accounting_firm?.business_name
              ? item?.accounting_firm?.business_name
              : formatName(
                  item?.assigned_to?.first_name,
                  item?.assigned_to?.last_name
                )
          })`
        : "");
    const id = item?.id;
    const items = { name, id, ...item };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });
  return (
    <Modal
      size="lg"
      show={showAcceptInvitation}
      onHide={toggleShowAcceptInvitationModal}
      dialogClassName="modal-50w small-popup review-popup small-review"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        Accept Invitation
      </Modal.Header>
      <Modal.Body>
        {(loading || projectLoading) && <Spin />}
        <div className="modal-body">
          Are your sure you want to accept this invitation?
          <div
            className="form-group full-width"
            style={{
              textAlign: "left",
              marginTop: "5px",
            }}
          >
            <label>
              <span className="required">*</span>Projects
            </label>
            <MultiSelect
              value={selectedProjects}
              selectedItemsLabel={`${selectedProjects?.length} Project(s) Selected`}
              name="builder_project_ids"
              onChange={(e) => {
                handleProjectChange(e);
              }}
              options={projectListing}
              optionLabel="label"
              // filter
              itemTemplate={(item) => (
                <span className={item?.assigned_to ? "grey-out" : ""}>
                  {item?.label}
                </span>
              )}
              placeholder="Select Projects"
              maxSelectedLabels={0}
              ref={filterProjectInputRef}
              panelFooterTemplate={
                <>
                  <hr />
                  <Button
                    className="multiSelect-button"
                    onClick={() => {
                      handleProjectApplyFilter();
                    }}
                  >
                    OK
                  </Button>
                  <Button
                    className="multiSelect-button"
                    onClick={() => {
                      ProjectResetFunction();
                    }}
                  >
                    Reset
                  </Button>
                </>
              }
            />
          </div>
        </div>
        <div className="modal-footer">
          <Button
            type="Button"
            className="btn btn-secondary"
            onClick={() => {
              toggleShowAcceptInvitationModal();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="btn btn-primary"
            data-dismiss="modal"
            disabled={selectedProjects?.length === 0 ? true : false}
            onClick={() => {
              handleAcceptInvitation();
            }}
          >
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BuilderAcceptInvitation;
